module.exports = __webpack_public_path__ + "static/media/play-background-3.7e8c1fc3.jpg";